import React from 'react';
import PropTypes from 'prop-types';
/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const IconArrowUp = ({colour}) => {
    const arrowColour = colour || 'white';
    return (
        <svg
            fill='none'
            style={{ width: '16px', height: '16px' }}
            viewBox='0 0 16 10'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M16 0.280029V1.69003L7.98 9.72003L0 1.70003V0.280029L7.98 8.30003L16 0.280029Z'
                fill={arrowColour}/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

IconArrowUp.propTypes = {
    colour: PropTypes.string
};

export default IconArrowUp;
